export default __webpack_public_path__ + "static/media/Wolfram.53fbbd15.png";